import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const serviceId = 5
const slug = 'data-cabling-and-network-installations-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Data Cabling & Network Installations",
        description: "Data cabling and network installations for homes, ensuring robust connectivity and efficient communication systems.",
        keywords: "data cabling Sydney, network installations Sydney, home data cabling, licensed electricians Sydney, structured cabling solutions, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Data Cabling & Network Installations',
    description: 'Setting up data cabling and network systems for reliable internet and communication infrastructure.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
